declare function translateText(pText: string): string;

export class Utils {
    private static readonly SESSION_ERROR_MSG = "Se perdio su sesion, por favor autentifiquese nuevamente en Deyel.";


    public static findElementById(elementId: string): HTMLElement | null {
        let currentWindow: Window | null = window;
        try {
            while (currentWindow) {
                const element: HTMLElement | null = currentWindow.document.getElementById(elementId);
                if (element) {
                    return element;
                }
                if (currentWindow === currentWindow.parent) {
                    break;
                }
                currentWindow = currentWindow.parent;
            }
        } catch (e) {
        }
        return null;
    }

    public static findFunctionByName(functionName: string): Function | null {
        let currentWindow: Window | null = window;
        try {
            while (currentWindow) {
                const candidate: any = (<any>currentWindow)[functionName];
                if (typeof candidate === "function") {
                    // Se devuelve enlazada a su ventana para preservar contexto (this).
                    return candidate.bind(currentWindow);
                }
                if (currentWindow === currentWindow.parent) {
                    break;
                }
                currentWindow = currentWindow.parent;
            }
        } catch (e) {
        }
        return null;
    }

    public static getAppLink(): string {
        const element: HTMLElement | null = Utils.findElementById('APPLICATION_LINK');
        if (element != null) {
            return (<HTMLInputElement>element).value;
        } else {
            let appLink = window.location.origin + "/";
            let path = window.location.pathname;
            if ((path.match(/\//g) || []).length > 1) {
                appLink += "/" + path.split("/")[1] + "/";
            }
            return appLink;
        }
    }

    public static redirectOnSessionError(): void {
        const onTokenExpired = Utils.findFunctionByName("cerrarSesionTokenExpired");
        if (onTokenExpired) {
            try {
                onTokenExpired();
                return;
            } catch (e) {
            }
        }

        let topWindow: Window = window;
        const appUrlElement = <HTMLInputElement>Utils.findElementById("app-url");
        let url = appUrlElement ? appUrlElement.value : null;
        const appLinkElement = <HTMLInputElement>Utils.findElementById("APPLICATION_LINK");
        const appLink = appLinkElement ? appLinkElement.value : null;
        let currentHref = window.location.href;

        try {
            if (window.top) {
                topWindow = window.top;
                currentHref = topWindow.location.href;
            }
        } catch (e) {
            topWindow = window;
        }

        if (url) {
            if (appLink && currentHref.indexOf(appLink) === 0) {
                url = appLink + url;
            } else {
                url = "/" + url;
            }
            topWindow.location.href = url;
        } else {
            topWindow.location.href = window.location.href;
        }
    }

    public static isSessionExpiredResponse(response: any): boolean {
        if (response == null) {
            return false;
        }

        if (typeof response === "string") {
            try {
                const parsed = JSON.parse(response);
                return Utils.isSessionExpiredResponse(parsed);
            } catch (e) {
                return Utils.isSessionExpiredMessage(response);
            }
        }

        if (typeof response === "object") {
            return Utils.isSessionExpiredMessage(response.message) || Utils.isSessionExpiredMessage(response.error);
        }

        return false;
    }

    public static isSessionExpiredMessage(message: any): boolean {
        if (typeof message !== "string" || message.trim() === "") {
            return false;
        }

        const normalizedMessage = Utils.normalizeText(message);
        const normalizedSessionErrorMessage = Utils.normalizeText(Utils.SESSION_ERROR_MSG);

        if (normalizedMessage === normalizedSessionErrorMessage) {
            return true;
        }

        const normalizedTranslatedMessage = Utils.normalizeText(Utils.translateText(message));
        const normalizedTranslatedSessionErrorMessage = Utils.normalizeText(Utils.translateText(Utils.SESSION_ERROR_MSG));

        return normalizedTranslatedMessage === normalizedTranslatedSessionErrorMessage;
    }

    private static translateText(text: string): string {
        try {
            if (typeof translateText === "function") {
                return translateText(text);
            }
        } catch (e) {
        }

        try {
            const btrb = (<any>window).BTRB;
            if (btrb && typeof btrb.getText === "function") {
                return btrb.getText(text);
            }
        } catch (e) {
        }

        return text;
    }

    private static normalizeText(text: string): string {
        return text
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/\s+/g, " ")
            .trim();
    }
}